<template>
  <div id="app" class="app">
    <router-view></router-view>
  </div>
</template>

<script>
//import { Toast } from 'mint-ui';

export default {
  name: 'app',
  data () {
      return {
        //shrink: false,
      };
  },
  computed: {
    menuList() {
      //return this.$store.state.app.menuList;
    },
  },
  methods: {
    init () {
      //this.$ajax.logout(this)
    },
  },
  mounted () {
      this.init();
  },
  created () {

  },
}
</script>
 
<style lang="less">
@import "./assets/reset.less";
@import "./assets/basis.less";
</style>



// WEBPACK FOOTER //
// src/App.vue